import { apiSalesWeb } from '@shared/config';
import { DocumentTypeEnum } from '@shared/types/PersonType';

export interface ICreateOnboardingInput {
  companyName: string;
  displayName?: string;
  documentNumber: string;
  documentType: DocumentTypeEnum;
  sessionAuthId: string;
  addressMetadata?: {
    postalCode: string;
    complement?: string;
    number: string;
    street: string;
    district: string;
    city: string;
    state: string;
  };
  phones?: string[];
  persons: {
    email: string;
    socialName?: string;
    name?: string;
    documentNumber: string;
    genre: string;
    birthDate?: string;
    phones?: string[];
    role: string;
  }[];
}
export interface ICreateOnboardingOutput {
  id: string;
}

export function createOnboardingInput({ ...payload }: ICreateOnboardingInput) {
  return apiSalesWeb.post<ICreateOnboardingOutput>('/onboarding', payload);
}
